import script from "./BultosTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BultosTable.vue?vue&type=script&setup=true&lang=js"

import "./BultosTable.vue?vue&type=style&index=0&id=32af21db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32af21db"]])

export default __exports__